{
  "version": 1,
  "asset_id": "cc4be79e-f0c9-41f3-b768-b918ed220a01",
  "project_id": "ce9c7bc3-4703-4722-9a23-513bcb210c19",
  "url": "/__l5e/assets-v1/cc4be79e-f0c9-41f3-b768-b918ed220a01/indigo.webp",
  "r2_key": "a/v1/ce9c7bc3-4703-4722-9a23-513bcb210c19/cc4be79e-f0c9-41f3-b768-b918ed220a01/indigo.webp",
  "original_filename": "indigo.webp",
  "size": 11756,
  "content_type": "image/webp",
  "created_at": "2026-07-17T21:18:04Z"
}
